/* unplugin-vue-components disabled */import { render } from "./BallotAnimate.vue?vue&type=template&id=6ec1542e&scoped=true"
const script = {}

import "./BallotAnimate.vue?vue&type=style&index=0&id=6ec1542e&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户内蒙古医科-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec1542e"]])

export default __exports__